import { X, CheckCircle2, Quote, Star } from "lucide-react";

const before = [
  "Vous devez rappeler constamment",
  "Discussions répétitives",
  "Frustration des deux côtés",
  "Aucune visibilité réelle",
];
const after = [
  "Le système fait les rappels",
  "Moins d'émotion, plus de structure",
  "Votre enfant devient responsable",
  "Vous voyez ce qui est réellement fait",
];

const testimonials = [
  {
    quote:
      "Avant, c'était une bataille tous les soirs. Maintenant, mon fils suit son plan et je n'ai presque plus besoin de lui rappeler.",
    name: "Marie",
    role: "maman d'un ado de 14 ans",
  },
  {
    quote:
      "Plan Étude a vraiment changé notre quotidien. Ma fille est plus autonome et ses notes se sont améliorées. Je recommande à 100 % !",
    name: "Julie",
    role: "maman d'une ado de 13 ans",
  },
];

const BeforeAfter = () => {
  return (
    <section
      id="avantages"
      data-testid="before-after-section"
      className="py-24 sm:py-28"
      style={{ background: "var(--sp-bg-subtle)" }}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="text-center max-w-2xl mx-auto">
          <div className="text-xs uppercase font-bold tracking-[0.2em] text-[#189346]">
            Avant / Après
          </div>
          <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-bold text-[#122118] leading-[1.1]">
            Avant et après Plan Étude
          </h2>
          <p className="mt-4 text-lg text-[#4a5f53]">
            Moins de rappels. Plus d'autonomie. De vrais résultats.
          </p>
        </div>

        <div className="mt-12 grid md:grid-cols-2 gap-6">
          {/* Avant */}
          <div
            className="rounded-3xl p-7 sm:p-8 border border-red-100 overflow-hidden"
            style={{ background: "#FFF6F5" }}
            data-testid="before-card"
          >
            <div className="text-xs uppercase font-bold tracking-[0.18em] text-[#FF3B30]">
              Avant Plan Étude
            </div>
            <h3 className="font-display text-xl font-bold text-[#122118] mt-2">
              Le quotidien sous tension
            </h3>
            <div className="mt-5 relative rounded-2xl overflow-hidden h-44 sm:h-48">
              <img
                alt="Mère épuisée par les devoirs du soir"
                src="https://images.pexels.com/photos/4143793/pexels-photo-4143793.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=700"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#FFF6F5] via-transparent to-transparent" />
            </div>
            <ul className="mt-5 space-y-3">
              {before.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-[#FFECEB] text-[#FF3B30] flex items-center justify-center shrink-0 mt-0.5">
                    <X className="w-3.5 h-3.5" strokeWidth={3} />
                  </span>
                  <span className="text-[#122118]">{item}</span>
                </li>
              ))}
            </ul>
          </div>

          {/* Après */}
          <div
            className="rounded-3xl p-7 sm:p-8 border overflow-hidden"
            style={{
              background: "#F1FCF5",
              borderColor: "rgba(37,211,102,0.25)",
            }}
            data-testid="after-card"
          >
            <div className="text-xs uppercase font-bold tracking-[0.18em] text-[#189346]">
              Après Plan Étude
            </div>
            <h3 className="font-display text-xl font-bold text-[#122118] mt-2">
              Une routine qui fonctionne
            </h3>
            <div className="mt-5 relative rounded-2xl overflow-hidden h-44 sm:h-48">
              <img
                alt="Mère détendue avec un café, sereine"
                src="https://images.pexels.com/photos/4145355/pexels-photo-4145355.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=400&w=700"
                className="w-full h-full object-cover"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-[#F1FCF5] via-transparent to-transparent" />
            </div>
            <ul className="mt-5 space-y-3">
              {after.map((item) => (
                <li key={item} className="flex items-start gap-3">
                  <span className="w-6 h-6 rounded-full bg-[#E9FBF0] text-[#189346] flex items-center justify-center shrink-0 mt-0.5">
                    <CheckCircle2 className="w-4 h-4" strokeWidth={2.5} />
                  </span>
                  <span className="text-[#122118]">{item}</span>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Testimonials */}
        <div className="mt-10 grid md:grid-cols-2 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="bg-white rounded-2xl p-7 shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100"
              data-testid={`testimonial-${i}`}
            >
              <Quote className="w-7 h-7 text-[#25D366]" />
              <p className="mt-3 text-[#122118] leading-relaxed">«&nbsp;{t.quote}&nbsp;»</p>
              <div className="mt-5 flex items-center justify-between">
                <div>
                  <div className="font-semibold text-[#122118]">— {t.name}</div>
                  <div className="text-sm text-[#4a5f53]">{t.role}</div>
                </div>
                <div className="flex items-center gap-0.5 text-[#FFB800]">
                  {[0, 1, 2, 3, 4].map((s) => (
                    <Star key={s} className="w-4 h-4 fill-current" />
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;
